import  { useState, useEffect } from 'react'
import  { useSWRConfig } from 'swr'
import { useNavigate } from 'react-router-dom'
import { apiScoreCode } from '../../api'

const fetcher = async (st1, st2) => {
            
               
  if (st1 && st2 ) {
     try{
      const data = await apiScoreCode(st1, st2);
      // Map score field to similarity for backward compatibility
      return { data: { similarity: data.score }, status: 200 };
}

    catch (error) {
      return error
    }

   


}}
const ZukiAiSc =  ({st1, st2}) => {

  const { mutate } = useSWRConfig();
  const navigate = useNavigate();
    
    const [similarity, setSimilarity] = useState(null);
    const [trigger, setTrigger] = useState(null);
    const [response, setResponse] = useState(null);
    const [afterfetch, setAfterfetch] = useState(false);
   


 
  
  


    useEffect(() => {
        if(trigger === null){
            setTrigger(true);
        }
    }, []);

    
 
          

          useEffect(() => {
            if(trigger === true){
            
            mutate("similarity",fetcher(st1, st2)
              .then(({data,status}) => {
                setResponse(status)
                setAfterfetch(true)
                data != null ? setSimilarity(data.similarity) : setSimilarity(null)
              },{
                revalidateOnFocus: false,
                revalidateOnReconnect: false,
                revalidateIfStale: true,
                errorRetryCount: 0,
                errorRetryInterval: 5000,
               
              }))}}
              

             
          , [ trigger, st1, st2,fetcher]);

          useEffect(() => {
            if (isNaN(similarity)) {
              mutate("similarity");
            }
          }, [similarity,trigger]);


          console.log("s:",similarity,"after:",afterfetch,"response:", response)
     useEffect(  () => {
       
       
     if(afterfetch === true && response === 200 && similarity==null){
    window.location.reload(); 
    }else if(afterfetch === true && response=== undefined && similarity==null){
      alert('Παρακαλώ προσπαθήστε αργότερα.')
      navigate('/');
    }
  }, [ response, afterfetch, similarity]);


      
      

    
    return(
      similarity === null ? NaN :   similarity
    )
    
}


ZukiAiSc.defaultProps = {
    st1: null,
    st2: null
}

export default ZukiAiSc